// extracted by mini-css-extract-plugin
export var cardIcon = "_5j-4";
export var checkboxCard = "_5j-0";
export var checkboxCardSelected = "_5j-3";
export var disabled = "_5j-1";
export var outerBorder = "_5j-2";
export var spacerMedium = "_5j-7";
export var spacerSmall = "_5j-6";
export var spacerXsmall = "_5j-5";